import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCanvasToolbarEnterFullscreen = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1 5V2h3M12 2h3v3M15 11v3h-3M4 14H1v-3" })
});
export default SvgCanvasToolbarEnterFullscreen;
